import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { InventoryItemInfo } from './components';
import { InventoryPreview, ItemClassPreview, AccountPreview } from "components";

const useStyles = makeStyles(theme => ({
  root: {},
  card: {
    marginBottom: theme.spacing(3),
  }
}));

const Summary = props => {
  const { className, handleDelete, ...rest } = props;
  const model = useSelector(state => state.models.item);

  const classes = useStyles();

  if (!model) {
    return null;
  }

  return (
    <Grid {...rest} className={clsx(classes.root, className)} container spacing={3}>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <ItemClassPreview itemClass={model.item_class} className={classes.card} />
        <InventoryItemInfo className={classes.card} />
      </Grid>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <AccountPreview accountId={model.inventory.account_id} className={classes.card} />
        <InventoryPreview inventoryId={model.inventory_id} className={classes.card} updateItemAccount />
      </Grid>
    </Grid>
  );
};

Summary.propTypes = {
  className: PropTypes.string
};

export default Summary;
